import React from 'react';
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained';
import SvgSuccessFilled from '@ntuctech/devex-tangram/Icon/SvgSuccessFilled';
import Modal from '@ntuctech/devex-tangram/Modal';
import ModalContent from '@ntuctech/devex-tangram/ModalContent';
import Typography from '@ntuctech/devex-tangram/Typography';
import styled from 'styled-components';

const FinishSc = styled(Modal)`
  border-radius: 0.25rem;
  padding: 2.5rem 3.5rem;
  text-align: center;
  width: 30rem;
  height: 23.25rem;

  @media (max-width: 767px) {
    padding: 2rem 1.5rem;
  }

  .success-icon {
    min-width: 5.7rem;
    min-height: 5.7rem;
    margin-top: 0.125rem;
  }
`;

const CenterIcon = styled.div`
  margin: auto;
  margin-bottom: 2.25rem;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    transparent 21%,
    rgba(63, 192, 120, 0.25),
    rgba(63, 192, 120, 0.25)
  );
`;

const ButtonGroupSc = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
`;

const ButtonContainedSc = styled(ButtonContained)`
  margin: 0;
`;

const Finish = (props) => {
  const { openFinishModal, handleOpenFinishModal, handleGetPhysicalCards, finishModalMsg } = props;

  const handleCloseFinishPopup = () => {
    handleGetPhysicalCards();
    handleOpenFinishModal(false);
  };

  return (
    <FinishSc open={openFinishModal}>
      <ModalContent>
        <CenterIcon>
          <SvgSuccessFilled color={'#3fc078'} className="success-icon" />
        </CenterIcon>
        <Typography variant="h3">Nice! Your card is on the way</Typography>
        <Typography variant="body2">{finishModalMsg}</Typography>
      </ModalContent>
      <ButtonGroupSc>
        <ButtonContainedSc data-testid="close_popup__button" onClick={handleCloseFinishPopup}>
          Okay, got it!
        </ButtonContainedSc>
      </ButtonGroupSc>
    </FinishSc>
  );
};

export default Finish;
